import InputMask from "react-input-mask";
import styles from "./styles.module.css"
import { forwardRef } from "react";

const Input = forwardRef(function Input({label, containerProps, mask, ...props}, ref){

    if(mask){
        return(
            <div {...containerProps} className={styles.container}>
                {label && <label>{label}</label>}
                <InputMask
                    mask={mask}
                    {...props}
                    ref={ref}
                />
            </div>
        )
    }

    return(
        <div {...containerProps} className={styles.container}>
            {label && <label>{label}</label>}
            <input {...props} ref={ref} />
        </div>    
    )
})

export default Input